import { Text } from '@ekhodealer/ekho-common/rev';

import { formatMessageTimestamp } from '@common/lib/time';

export interface MessageTimestampProps {
	/** ISO timestamp of when the message was created. */
	createdAt: string;
	/** Text alignment for the timestamp. */
	align?: 'left' | 'center' | 'right';
}

export const MessageTimestamp = ({ createdAt, align }: MessageTimestampProps): React.ReactNode => {
	return (
		<Text size='caption' color='tertiary' align={align}>
			{formatMessageTimestamp(createdAt)}
		</Text>
	);
};
